<template slot-scope="scope">
  <!-- 车险活动购买信息弹窗 -->
      <dialogModel
        title="下载"
        :visible.sync="dialogDownload"
        @handleClose="handleCloseDownload"
        @handleOk="handleDow"
      >
        <div v-loading="loading">
          <p class="Hint-p">是否下载已选中内容？</p>
        </div>
      </dialogModel>
</template>

<script>
import {} from "../../../../../assets/api/index";
export default {
  props: {
    dialogDownload: {},
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    dialogDownload: {
      handler(newSs, old) {
        this.loading = false;
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    // 关闭弹窗
    handleCloseDownload() {
      this.$emit("handleCloseDownload");
    },
    handleDow() {
      this.loading = true;
      this.$emit("handleDow");
    },
  },
};
</script>

<style scoped lang="less">
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
</style>
